import { render, staticRenderFns } from "./SDCampaignRequestAccount.vue?vue&type=template&id=31b98592&scoped=true"
import script from "./SDCampaignRequestAccount.vue?vue&type=script&lang=js"
export * from "./SDCampaignRequestAccount.vue?vue&type=script&lang=js"
import style0 from "./SDCampaignRequestAccount.vue?vue&type=style&index=0&id=31b98592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b98592",
  null
  
)

export default component.exports